import { portCallTypeRefDataSource } from '../state/port-call-type-datasource'

/**
 * Shared port-call-type reference data for select/combobox pickers. All callers
 * share one module-level cache (see `state/port-call-type-datasource.ts`).
 */
export function useSelectPortCallTypeDataSource() {
  return {
    portCallTypes: portCallTypeRefDataSource.items,
    loadingPortCallTypes: portCallTypeRefDataSource.loading,
    fetchPortCallTypes: portCallTypeRefDataSource.fetch
  }
}
